<template>
  <FormItem>
    <Checkbox 
      v-model="val"
      size="large"
    >{{ content }}
    </Checkbox>
  </FormItem>
</template>

<script>
  import { FormItem, Checkbox } from 'iview';

  export default {
    components: { FormItem, Checkbox },
    props: {
      value: {
        type: Boolean,
        default: false
      },
      content: {
        type: String,
        default: ''
      }
    },
    computed: {
      val: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val);
        }
      }
    }
  };
</script>
